module.exports = __webpack_public_path__ + "img/IMG_1634.cd87dfd9.jpg";